import {useEffect, useState} from "react";
import {useInView} from "react-intersection-observer";
import useGetAllOrders from "../../hooks/useGetAllOrders";
import Spinner from "../spinner/Spinner";
import {OrderProps} from "../../types/ComponentProps";
import OrderStatusDropDown from "../orderStatusDropDown/OrderStatusDropDown";
import OderListStyles from "./OrderListStyles.module.css";

const OrderList = () => {
  const {ref, inView} = useInView();
  const {data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage} =
    useGetAllOrders();
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const [expandedAddresses, setExpandedAddresses] = useState<
    Record<number, boolean>
  >({});
  const orderList = data?.pages.flatMap((data: any) => data.orders) || [];

  const toggleRow = (index: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleAddress = (index: number) => {
    setExpandedAddresses((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, isFetchingNextPage, hasNextPage, fetchNextPage]);

  return (
    <div className={OderListStyles.manageAddOnListBlk}>
      <div className={OderListStyles.manageProductBlkTitle}>
        <h1>Orders</h1>
      </div>

      <div className={OderListStyles.addOnListMainContainer}>
        {isLoading ? (
          <div style={{display: "block", padding: "10px 0"}}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        ) : orderList.length === 0 ? (
          <p className={OderListStyles.notAvailableBlkTxt}>
            No orders are currently available
          </p>
        ) : (
          <table className={OderListStyles.accessibleTable} aria-label="Orders">
            <thead>
              <tr>
                <th scope="col">Order No.</th>
                <th scope="col">Type</th>
                <th scope="col">Employee Name</th>
                <th scope="col">Product Details</th>
                <th scope="col">Email</th>
                <th scope="col">Amount</th>
                <th scope="col">Date</th>
                <th scope="col">Address</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {orderList.map((order: OrderProps, index: number) => (
                <tr key={index}>
                  <td>{order?.orderId}</td>
                  <td>{order?.orderDetails?.type}</td>
                  <td>{order?.fullName}</td>
                  <td>
                    <button
                      type="button"
                      className={OderListStyles.cellToggleButton}
                      onClick={() => toggleRow(index)}
                      aria-expanded={expandedRows[index] || false}
                      aria-label={`Toggle product details for order ${order?.orderId}`}
                    >
                      {expandedRows[index] ? (
                        <span>
                          <b>Product Name:</b> {order?.orderDetails?.productName}
                        </span>
                      ) : (
                        <span>
                          {order?.orderDetails?.productName.substring(0, 20)}...
                        </span>
                      )}
                      <i
                        className={`fa-solid ${
                          expandedRows[index] ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                        style={{marginLeft: "10px"}}
                      />
                    </button>
                  </td>
                  <td>{order?.email}</td>
                  <td>{order?.orderDetails?.price}</td>
                  <td>
                    {order?.createdAt
                      ? new Date(order.createdAt).toLocaleString()
                      : "-"}
                  </td>
                  <td>
                    <button
                      type="button"
                      className={OderListStyles.cellToggleButton}
                      onClick={() => toggleAddress(index)}
                      aria-expanded={expandedAddresses[index] || false}
                      aria-label={`Toggle address for order ${order?.orderId}`}
                    >
                      <span>
                        {expandedAddresses[index]
                          ? `${order?.city} ${order?.province} ${order?.postalCode} ${order?.landmarks}`
                          : `${order?.city} ${order?.province}...`}
                      </span>
                      <i
                        className={`fa-solid ${
                          expandedAddresses[index]
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                        }`}
                        style={{marginLeft: "10px"}}
                      />
                    </button>
                  </td>
                  <td>
                    <OrderStatusDropDown order={order} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div ref={ref} style={{height: "1px"}}></div>
        {isFetchingNextPage && (
          <div style={{display: "block", padding: "20px 0px"}}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderList;
